import { QueryErrorResetBoundary } from "@tanstack/react-query";
import type { ComponentType, PropsWithChildren } from "react";
import { ErrorBoundary, type FallbackProps } from "react-error-boundary";
import { Svg } from "../svg";
import { Button } from "./Button";
import { StatusPlaceholder } from "./StatusPlaceholder";

function GenericErrorFallback(props: FallbackProps) {
	return (
		<StatusPlaceholder
			label="Oops!"
			sublabel="An unknown error occurred while processing your request"
			image={Svg.ServerDown}
		>
			<Button onClick={props.resetErrorBoundary} size="sm" variant="danger">
				Try again
			</Button>
		</StatusPlaceholder>
	);
}

export function GenericErrorBoundary(props: PropsWithChildren) {
	return (
		<QueryErrorBoundary fallback={GenericErrorFallback}>
			{props.children}
		</QueryErrorBoundary>
	);
}

export function QueryErrorBoundary(
	props: PropsWithChildren<{
		fallback: ComponentType<FallbackProps>;
	}>,
) {
	return (
		<QueryErrorResetBoundary>
			{({ reset }) => (
				<ErrorBoundary FallbackComponent={props.fallback} onReset={reset}>
					{props.children}
				</ErrorBoundary>
			)}
		</QueryErrorResetBoundary>
	);
}
